import "./About.scss";
import ebp from 'url:../../../static/ebpenglishSchool.png';
import blablabook from 'url:../../../static/blablabook.png';
import fraisbio from 'url:../../../static/fraisbio.png';


export default function About() {
  return (
    <div className="about">
      <h1>À propos de moi</h1>
      <h2>Nouhayla Er-Raysy</h2>

      <p>
        Développeuse web freelance, titulaire d’un Titre Professionnel de Développeuse Web et Web Mobile
        ainsi que d’un Bac+5 en bioinformatique et biostatistique, je me spécialise dans la création de sites web modernes et performants.
      </p>

      <p>
        J’accompagne les entrepreneurs, associations et petites entreprises dans la création de sites vitrines,
        e-commerce et applications web sur mesure. De la conception au déploiement, je développe des solutions
        adaptées à vos objectifs avec des technologies modernes (HTML, CSS, JavaScript, React.js, Node.js, WordPress).
      </p>

      <p>
        Mon objectif est de concevoir des sites web rapides, ergonomiques et optimisés pour le référencement (SEO),
        afin d’améliorer votre visibilité et votre présence en ligne.
      </p>

      <p>
        Sérieuse, à l’écoute et orientée résultat, je vous accompagne dans la réalisation de votre projet digital
        avec une approche professionnelle et personnalisée.
      </p>
      <div className="portfolio">

  

</div>
    </div>
    
    
  );
}